export class SiteSelectComponentItemModel {
  public guid: string;
  public domain: string;

  [ key: string ]: any;
}
